import { render, staticRenderFns } from "./EipImg.vue?vue&type=template&id=4675ccbc&scoped=true&"
import script from "./EipImg.vue?vue&type=script&lang=js&"
export * from "./EipImg.vue?vue&type=script&lang=js&"
import style0 from "./EipImg.vue?vue&type=style&index=0&id=4675ccbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675ccbc",
  null
  
)

export default component.exports